module.exports = __webpack_public_path__ + "ba7e98d4ae7c78c945842cf2d2776252.webp";